import { useMemo, useState } from 'react';
import { DatePeriod, DateRange, DateRangeDropdown, getDateRangeByPeriod } from '@mews/b2b-ui/DateRangePicker';
import { DateTimeService, DateTimeUtils, useLocalizeText, useTimezone } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { NativeCalendarService } from '@optimus-web/core';

const convertISODateToStartOfDayUTCString = (date: string, timezone: string) => {
    const parsedDate = DateTimeUtils.dateIsoStringToDateTime(date, timezone);
    return DateTimeService.toUtc(DateTimeService.startOfDay(parsedDate)).value;
};

const convertISODateToEndOfDayUTCString = (date: string, timezone: string) => {
    const parsedDate = DateTimeUtils.dateIsoStringToDateTime(date, timezone);
    return DateTimeService.toUtc(DateTimeService.endOfDay(parsedDate)).value;
};

export const useDateFilter = () => {
    const [dateRange, setDateRange] = useState<DateRange>({
        datePeriod: DatePeriod.ThisQuarter,
    });

    const localizeText = useLocalizeText();

    const timezone = useTimezone();
    const dateRangeDates = useMemo(() => {
        if (dateRange.datePeriod === DatePeriod.Custom) {
            return {
                startDate: convertISODateToStartOfDayUTCString(dateRange.startDate, timezone),
                endDate: convertISODateToEndOfDayUTCString(dateRange.endDate, timezone),
            };
        }

        const dateRangeByPeriod = getDateRangeByPeriod(dateRange.datePeriod, timezone);

        return {
            startDate: convertISODateToStartOfDayUTCString(dateRangeByPeriod.startDate, timezone),
            endDate: convertISODateToEndOfDayUTCString(dateRangeByPeriod.endDate, timezone),
        };
    }, [dateRange, timezone]);

    return {
        filterComponent: (
            <DateRangeDropdown
                prefix={localizeText({ textKey: TextKey.Period })}
                calendarService={NativeCalendarService}
                dateRange={dateRange}
                onChange={setDateRange}
            />
        ),
        dateRangeDates,
    };
};
